import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';// eslint-disable-line no-unused-vars
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import Checkbox from 'material-ui/Checkbox';
import Pagination from '../../components/home/Pagination';
import _ from 'lodash';

const propTypes = {
  campaigns: PropTypes.any,
  campaign: PropTypes.object,
  products: PropTypes.array,
  navigation: PropTypes.func.isRequired,
  salesChannels: PropTypes.array,
  productsMeta: PropTypes.object,
};

class ViewCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let campaign = nextProps.campaign;
    let products = [];
    if (campaign.id) {
      campaign = nextProps.campaign;
      products = nextProps.products;
    } else {
      campaign = nextProps.campaigns.results[0];
    }
    campaign.id = (campaign.id === null) ? 0 : campaign.id;
    this.setState({ campaign, products });
  }
  navigateToEdit() {
    browserHistory.push(`/campaigns/${this.props.campaign.id}`);
  }
  handleCancel() {
    browserHistory.push('/campaigns?page=1');
  }
  renderProductRowsTable() {
    const getProductName = (product) => { // eslint-disable-line arrow-body-style
      let productName = product.name;
      const idArray = _.map(product.items, 'id');
      const defaultEnabled = idArray.includes(product.defaultItemId);
      if (!defaultEnabled) {
        productName = `* ${productName}`;
      }
      return (productName);
    };
    const products = _.filter(this.state.products, (product) => this.state.campaign.products.includes(product.id));
    return products.map((product, i) =>
      <TableRow key={i}>
        <TableRowColumn key={i}>{getProductName(product)}</TableRowColumn>
        <TableRowColumn key={i}>{_.result(_.pick(_.find(product.items, { id: product.defaultItemId }), ['name']), 'name')}
        </TableRowColumn>
        <TableRowColumn key={i}>
          <Checkbox
            defaultChecked={this.state.campaign.featuredProduct === product.id}
            name="featuredProduct"
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    const styles = {
      scrollDivStyle: {
        width: '250px',
        display: 'inline-block',
        color: cyan900,
        fontSize: '12px',
        marginTop: '10px',
      },
      listStyle: {
        display: 'inline-block',
        verticalAlign: 'text-top',
        height: '70px',
        overflow: 'auto',
      },
      floatingLabelStyle: {
        color: cyan900,
      },
      textStyle: {
        marginRight: '2%',
        width: '600px',
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
    };
    return (
      <div style={{ width: '100%' }}>
        <h2>View Campaign</h2>
        <div className="content">
          <div className="float-right">
            <RaisedButton
              style={{ marginRight: '20px' }}
              label="Cancel"
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Edit"
              primary
              onClick={this.navigateToEdit}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={this.props.campaign.id || ''}
            disabled
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.name || ''}
            name="name"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Logo Image"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.logoImage || ''}
            name="logoImage"
            style={styles.inputStyle}
          />
          <br />
          <TextField
            floatingLabelText="Campaign Email"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.sentTo || ''}
            name="sentTo"
            style={styles.inputStyle}
          />
          <br />
          <br />
          <TextField
            floatingLabelText="Email From"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.emailFrom || ''}
            name="emailFrom"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Email Reply To"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.emailReplyTo || ''}
            name="emailReplyTo"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Email Bcc"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.emailBcc || ''}
            name="emailBcc"
            style={styles.inputStyle}
          />
          <br />
          <TextField
            floatingLabelText="Sales Channel"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={_.result(_.pick(_.find(this.props.salesChannels, { id: this.props.campaign.salesChannelId }), ['name']), 'name') || ''} // eslint-disable-line max-len
            name="salesChannel"
            style={styles.inputStyle}
          />
          <br />
          <br />
          <ul>
            <li>
              <Checkbox
                label="Disabled"
                checked={this.props.campaign.disabled}
                name="disabled"
                onCheck={this.handleChange}
              />
            </li>
          </ul>
        </div>
        <br />
        <br />
        <h2>Trigger One</h2>
        <div className="content">
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.emailSubject || ''}
            name="emailSubject"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
          <TextField
            floatingLabelText="Email Headline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.emailHeadline || ''}
            name="emailHeadline"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.emailBody || ''}
            name="emailBody"
            multiLine
            rows={3}
            style={styles.textStyle}
          />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={this.props.campaign.emailSubjectPromo || ''}
                name="emailSubjectPromo"
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
          <TextField
            floatingLabelText="Email Headline Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.emailHeadlinePromo || ''}
            name="emailHeadlinePromo"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.emailBodyPromo || ''}
            name="emailBodyPromo"
            multiLine
            rows={3}
            style={styles.textStyle}
          />
            </div>
          </div><br />
        </div>
        <h2>Trigger Two</h2>
        <div className="content">
        <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email2Subject || ''}
            name="email2Subject"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email2Headline || ''}
            name="email2Headline"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email2Body || ''}
            name="email2Body"
            multiLine
            rows={3}
            style={styles.textStyle}
          />
            </div>
          </div>
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email2SubjectPromo || ''}
            name="email2SubjectPromo"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email2HeadlinePromo || ''}
            name="email2HeadlinePromo"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email2BodyPromo || ''}
            name="email2BodyPromo"
            multiLine
            rows={3}
            style={styles.textStyle}
          />
            </div>
          </div>
          <br />
        </div>
        <h2>Trigger Three</h2>
        <div className="content">
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email3Subject || ''}
            name="email3Subject"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email3Headline || ''}
            name="email3Headline"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email3Body || ''}
            name="email3Body"
            multiLine
            rows={3}
            style={styles.textStyle}
          />
            </div>
          </div>
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email3SubjectPromo || ''}
            name="email3SubjectPromo"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email3HeadlinePromo || ''}
            name="email3HeadlinePromo"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email3BodyPromo || ''}
            name="email3BodyPromo"
            multiLine
            rows={3}
            style={styles.textStyle}
          />
            </div>
          </div>
        </div>
        <h2>Trigger Four</h2>
        <div className="content">
        <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email4Subject || ''}
            name="email4Subject"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email4Headline || ''}
            name="email4Headline"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email4Body || ''}
            name="email4Body"
            multiLine
            rows={3}
            style={styles.textStyle}
          />
            </div>
          </div>
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email4SubjectPromo || ''}
            name="email4SubjectPromo"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email4HeadlinePromo || ''}
            name="email4HeadlinePromo"
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.campaign.email4BodyPromo || ''}
            name="email4BodyPromo"
            multiLine
            rows={3}
            style={styles.textStyle}
          />
            </div>
          </div>
          <br />
        </div>
        <h2>Campaign Products</h2>
        <div className="content">
          <div>
            <div className="action-buttons top">
              <Pagination
                paginationInfo={this.props.productsMeta}
                pageCall={route => this.props.navigation(route)}
                pageName={`/campaigns/${_.get(this, 'props.campaign.id')}`}
              />
            </div>
          </div>
          <Table
            wrapperStyle={{ overflow: 'inherit' }}
            selectable={tableStyles.selectable}
            multiSelectable={tableStyles.multiSelectable}
          >
            <TableHeader
              displaySelectAll={tableStyles.displaySelectAll}
              adjustForCheckbox={tableStyles.adjustForCheckbox}
            >
              <TableRow
                selectable={tableStyles.selectable}
              >
                <TableHeaderColumn>Product Name</TableHeaderColumn>
                <TableHeaderColumn>Default Item</TableHeaderColumn>
                <TableHeaderColumn>Featured Product</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              stripedRows={tableStyles.stripedRows}
              displayRowCheckbox={tableStyles.displayRowCheckbox}
            >
              {this.renderProductRowsTable()}
            </TableBody>
          </Table>
        </div>
        <div className="action-buttons bottom">
          <Pagination
            style={{ marginRight: '25px' }}
            paginationInfo={this.props.productsMeta}
            pageCall={route => this.props.navigation(route)}
            pageName={`/campaigns/${_.get(this, 'props.campaign.id')}`}
          />
        </div>
        <span style={{ marginLeft: '100px' }}>* The default item for this product is not enabled.</span>
      </div>
    );
  }
}

ViewCampaign.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewCampaign.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    campaigns: state.campaigns,
    campaign: state.campaigns.campaign,
    products: state.products.results,
    salesChannels: state.salesChannels.results,
  };
}

export default connect(mapStateToProps)(ViewCampaign);



// WEBPACK FOOTER //
// ./src/components/campaigns/ViewCampaign.js